import { computed } from 'vue'
import { getGametypeOrder } from '@/helpers/constants'
import { SNK } from '@/helpers/helpers'
import { useStore } from 'vuex'

export function useTier(namespace: string) {
  const store = useStore()

  const user_info = computed(() => store.getters.user_info)

  const affiliateName = computed(() => store.getters.user_info.affiliate_name)

  const subs = computed(() => user_info.value.subs || [])

  const allSubs = computed(() => {
    const res = JSON.parse(JSON.stringify(user_info.value.subs || []))
    const order = getGametypeOrder()
    return res.sort((a, b) =>
      order.indexOf(a.plan?.type.toLowerCase()) < order.indexOf(b.plan?.type.toLowerCase())
        ? -1
        : 1,
    )
  })

  const purchasedSubs = computed(() =>
    allSubs.value.filter(sub => sub?.plan?.type?.toLowerCase() !== 'any'),
  )

  const purchasedSubsNoCancel = computed(() => {
    const res = purchasedSubs.value.filter(i => !i.canceled)
    const order = getGametypeOrder()
    return res.sort((a, b) =>
      order.indexOf(a.plan?.type.toLowerCase()) < order.indexOf(b.plan?.type.toLowerCase())
        ? -1
        : 1,
    )
  })

  const notPurchasedTypes = computed(() => {
    const all = [
      'cash',
      // 'straddle_ante_cash', not accessible in free tier !!!
      'mtt',
      'spins',
      'husng',
      // 'SHORTDECK',
    ]
    const purchased = subs.value.map(sub => sub.plan.type.toLowerCase())
    return all.filter(type => !purchased.includes(type))
  })

  const gameformat = computed(() => store.getters[SNK('gameformat', namespace)])

  const tm_accessInPremiumSubOnly = computed(() => !gameformat.value.subscription_tier)

  const nadaPurchased = computed(() => {
    const res = purchasedSubs.value.some(
      i =>
        i.plan.tier.toLowerCase() === 'elite' ||
        i.plan.tier.toLowerCase() === 'premium' ||
        i.plan.tier.toLowerCase() === 'starter',
    )
    return !res
  })

  const anyPremiumTierPurchased = computed(() =>
    purchasedSubs.value.some(i => i.plan.tier.toLowerCase() === 'premium'),
  )

  const starterPurchasedForCurrentGametypeGroup = computed(() => {
    const { gameformats } = store.getters
    return gameformats.some(
      i => i.group === gameformat.value?.group && i.subscription_tier === 'STARTER',
    )
  })

  const gameformatTrial = computed(() => gameformat.value?.subscription_tier === 'TRIAL')

  const gameformatStarter = computed(() => gameformat.value?.subscription_tier === 'STARTER')

  const gameformatPremium = computed(() => gameformat.value?.subscription_tier === 'PREMIUM')

  const gameformatElite = computed(() => gameformat.value?.subscription_tier === 'ELITE')

  const gameformatPurchased = computed(
    () => gameformatStarter.value || gameformatPremium.value || gameformatElite.value,
  )

  const gameformatSubscribed = computed(() => gameformat.value?.is_subscribed)

  const gameformatFree = computed(() => !gameformatTrial.value && !gameformatPurchased.value)

  const gameformatAny = computed(() =>
    allSubs.value.some(i => i.plan?.tier?.toLowerCase() === 'any'),
  )

  return {
    user_info,
    affiliateName,
    subs,
    allSubs,
    purchasedSubs,
    purchasedSubsNoCancel,
    notPurchasedTypes,
    gameformat,
    tm_accessInPremiumSubOnly,
    nadaPurchased,
    anyPremiumTierPurchased,
    starterPurchasedForCurrentGametypeGroup,
    gameformatTrial,
    gameformatStarter,
    gameformatPremium,
    gameformatElite,
    gameformatPurchased,
    gameformatSubscribed,
    gameformatFree,
    gameformatAny,
  }
}
